import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_WEEK_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, weekBookingAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";

const request = data => {
    return fetch(`${ url }/get_week_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetWeekBooking(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', args.data?.establishment);
        formData.append('date', args.data?.date || '');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            yield put(weekBookingAction(response.booking));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetWeekBooking() {
    yield takeLatest(GET_WEEK_BOOKING_SAGA, workerGetWeekBooking);
}